export const Socket = () => {
    return (
        <svg aria-hidden="true" viewBox="0 0 48 48" fill="currentColor">
            <path d="M21 18H27V10H31V18H35V26L29 31V33H19V31L13 26V18H17V10H21V18Z" />
            <path d="M29 36H19V40H29V36Z" />
        </svg>
    );
};
